"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var REQUIRED_REGEXP = /^\S+/;
exports.requiredValidator = {
    name: 'required',
    validation: function validateCheckboxAndRadiobutton(value, element) {
        if (element instanceof HTMLFieldSetElement) {
            return Array.from(element.querySelectorAll('input'))
                .filter(function (input) { return utils_1.isRadiobuttonOrCheckbox(input); })
                .filter(function (input) { return input.closest('fieldset') === element; })
                .some(function (input) { return input.checked; });
        }
        else if (utils_1.isRadiobuttonOrCheckbox(element)) {
            return element.checked;
        }
        else {
            return REQUIRED_REGEXP.test(value);
        }
    },
};
//# sourceMappingURL=RequiredValidator.js.map